import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { FINCORE_API_KEY } from '../model/fincore';
import { Environment } from '../model/environment';

export function resolveFincoreBaseUrl(config: Environment): string {
  const restUrl = config.REST_SERVER_url.find(
    (entry) => entry.api === FINCORE_API_KEY
  );
  if (!restUrl?.url) {
    throw new Error(
      "FINCORE is not configured in environment REST_SERVER_url"
    );
  }
  const host = (restUrl.host || config.REST_SERVER_HOST || '').replace(
    /\/$/,
    ''
  );
  return `${host}${restUrl.url}`;
}

export function createFincoreHeaders(): HttpHeaders {
  return new HttpHeaders({
    'Content-Type': 'application/json',
    DoNotIntercept: 'true',
  });
}

export function handleFincoreHttpError(error: HttpErrorResponse) {
  if (error.error instanceof ErrorEvent) {
    console.error('An error occurred:', error.error.message);
  } else {
    console.error(
      `Backend returned code ${error.status}, body was: ${error.error}`
    );
  }
  return throwError(error);
}

export function formatFincoreError(e: unknown): string {
  if (e && typeof e === 'object' && 'error' in e) {
    const errBody = (e as { error?: unknown }).error;
    if (typeof errBody === 'string' && errBody.length > 0) {
      return errBody;
    }
    if (errBody && typeof errBody === 'object' && 'message' in errBody) {
      const m = (errBody as { message?: unknown }).message;
      if (typeof m === 'string') {
        return m;
      }
    }
  }
  if (e && typeof e === 'object' && 'message' in e) {
    const m = (e as { message?: unknown }).message;
    if (typeof m === 'string') {
      return m;
    }
  }
  return 'Request failed. Is FinCore running with a non-bootstrap profile (e.g. token) on port 8075?';
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Added shared FinCore HTTP helpers resolveFincoreBaseUrl(), createFincoreHeaders(), handleFincoreHttpError(), and formatFincoreError(). Previous behavior: No FinCore URL/header/error helpers; MITENS uses host+url while MBE uses REST_SERVER_HOST+url. New behavior: Base URL is (entry.host || REST_SERVER_HOST) + '/api/fincore' with trailing slash stripped; headers set Content-Type application/json and DoNotIntercept true like RtcService; errors parse Spring string or {message} bodies. Reason: DRY for monthly-fee and account-maintenance services; local FinCore is http://localhost:8075 while deployed envs use REST_SERVER_HOST. Context: Portaladmin FinCore REST integration. Impact: Both FinCore services share URL construction; missing FINCORE env entry throws at construction. - 2026-08-20 - HE
